<template>
	<div class="app-icon" v-on="$listeners">
		<svg
			xmlns="http://www.w3.org/2000/svg"
			:viewBox="icon.viewBox"
			:aria-labelledby="iconName"
			role="presentation"
		>
			<title
				:id="iconName"
				lang="en"
			>
				{{ iconName }} icon
			</title>

			<g :fill="iconColor">
				<slot>
					<path
						v-if="iconName"
						:d="icon.d"
						:transform="icon.transform"
					/>
				</slot>
			</g>
		</svg>
	</div>
</template>

<script>
import icons from '@/meta/icons'
export default {
	props: {
		iconName: {
			type: String,
			default: ''
		},

		iconColor: {
			type: String,
			default: 'currentColor'
		}
	},

	computed: {
		icon () {
			return icons[this.iconName]
		}
	}
}
</script>

<style lang="scss" scoped>
.app-icon {
	display: inline-block;

	svg {
		width: 100%;
		height: 100%;
		pointer-events: none;
	}
}
</style>
